export interface MaskablePatientIdentity {
  patient_id?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  mrn?: string | null;
  date_of_birth?: string | Date | null;
  birth_year?: number | null;
  _anonymized?: boolean | null;
}

export function isMaskedPatient(
  patient?: MaskablePatientIdentity | null,
): boolean {
  return Boolean(patient?._anonymized);
}

export function getPatientDisplayName(
  patient?: MaskablePatientIdentity | null,
  options?: {
    maskedLabel?: string;
    fallbackLabel?: string;
  },
): string {
  if (!patient) {
    return options?.fallbackLabel || "Unknown patient";
  }

  if (isMaskedPatient(patient)) {
    return options?.maskedLabel || "Masked patient";
  }

  const displayName = [patient.first_name, patient.last_name]
    .map((part) => String(part || "").trim())
    .filter(Boolean)
    .join(" ")
    .trim();

  return displayName || patient.patient_id || options?.fallbackLabel || "Unknown patient";
}

export function getPatientRecordLabel(
  patient?: MaskablePatientIdentity | null,
  options?: {
    maskedLabel?: string;
    fallbackLabel?: string;
  },
): string {
  if (!patient) {
    return options?.fallbackLabel || "N/A";
  }

  if (isMaskedPatient(patient)) {
    return options?.maskedLabel || "Reveal required";
  }

  const mrn = String(patient.mrn || "").trim();
  if (mrn.length > 0) {
    return mrn;
  }

  return patient.patient_id || options?.fallbackLabel || "N/A";
}

export function getPatientBirthYearLabel(
  patient?: MaskablePatientIdentity | null,
): string {
  if (!patient || !isMaskedPatient(patient)) {
    return "";
  }

  if (typeof patient.birth_year === "number") {
    return String(patient.birth_year);
  }

  return "Masked";
}